import e from "../../utils/classNames.js";
import { isNil as t } from "es-toolkit/predicate";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/selects/ClearButton.tsx
var r = (r) => {
	let { showClear: i, selectedItem: a, onClear: o } = r, s = e("clearButton", (!i || t(a)) && "hide pointer-events-none");
	return /* @__PURE__ */ n("span", {
		className: s,
		onClick: (e) => {
			e.stopPropagation(), o();
		},
		children: /* @__PURE__ */ n("span", { className: "clearButtonIcon uikit-icon icon-remove-sign" })
	});
};
//#endregion
export { r as default };

//# sourceMappingURL=ClearButton.js.map